import { createTheme } from '@mui/material/styles';

export const darkTheme = createTheme({
  typography: {
    fontFamily: '"Arial", sans-serif',
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#e0e0e0',
    },
    secondary: {
      main: '#757575',
    }
  }
});

export const lightTheme = createTheme({
  typography: {
    fontFamily: '"Arial", sans-serif',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#e0e0e0',
    },
    secondary: {
      main: '#757575',
    }
  }
});